<template>
  <el-dialog title="批量修改会员等级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">

    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">

      <el-form-item label="等级" :label-width="formLabelWidth" >
        <el-select v-model="form.grade_id" placeholder="-默认等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        /*是否显示*/
        dialogVisible: false,
        /*form表单对象*/
        form: {
          access_id: []
        },
        /*form验证*/
        formRules: {
          grade_id: [
            {
              required: true,
              message: ' ',
              trigger: 'blur'
            }
          ],
        }
      };
    },
    props: ['open', 'roleList','gradeList','user_ids'],

    watch: {
      open: function(n, o) {
        if (n != o) {
          this.dialogVisible = this.open;
        }
      }
    },
    created() {
     // console.log(this.user_ids);
    },
    methods: {
      /*批量修改*/
      onSubmit() {
        let user_ids=this.user_ids;
        let self = this;
        self.loading = true;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if(valid){
            UserApi.BatchChangegrade({
              params:params,
              user_ids:user_ids
            }).then(data => {
                self.loading = false;
                self.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.form.grade_id=''
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.loading = false;
              });
          }if(!valid){
            self.loading = false;
          }

        });

      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
</script>

<style></style>




// WEBPACK FOOTER //
// src/views/user/user/dialog/Changegrade.vue